import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import PenilaianRepository from '../Repositories/PenilaianRepository'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/penilaian360Service'


class PenilaianBloc
{
    repository = new PenilaianRepository()
    recapPeriodListChannel = new Subject()
    recapPeriodDetailChannel = new Subject()
    recapDataTableChannel = new Subject()
    recapDownloadChannel = new Subject()
    recapOrganizationChannel = new Subject();

    constructor(){
        this.recapPeriodListChannel.next({status: apiResponse.INITIAL})
        this.recapPeriodDetailChannel.next({status: apiResponse.INITIAL})
        this.recapDataTableChannel.next({status: apiResponse.INITIAL})
        this.recapDownloadChannel.next({status: apiResponse.INITIAL})
        this.recapOrganizationChannel.next({status: apiResponse.INITIAL})
    }

    fetchOrganization = async (query) => {
        this.recapOrganizationChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchOrganization(query).then((result) => {
            this.recapOrganizationChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapOrganizationChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRecapDownload = async (query) => {
        this.recapDownloadChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRecapDownload(query).then((result) => {
            this.recapDownloadChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapDownloadChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
    fetchDataTable = async (query, cancelToken) => {
        this.recapDataTableChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDataTable(query, cancelToken).then((result) => {
            this.recapDataTableChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapDataTableChannel.next({status: apiResponse.ERROR, data: error})
        })
    }


    fetchRecapPeriod = async (query, cancelToken) => {
        this.recapPeriodListChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRecapPeriod(query, cancelToken).then((result) => {
            this.recapPeriodListChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapPeriodListChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRecapDetailPeriod = async (query) => {
        this.recapPeriodDetailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRecapDetailPeriod(query).then((result) => {
            this.recapPeriodDetailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapPeriodDetailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}


export default PenilaianBloc